export const applyTemplateVariables = ({
  rawContent,
  variables,
}: {
  rawContent: string | null | undefined;
  variables: Record<string, string | null | undefined>;
}): string => {
  if (!rawContent) return '';

  return rawContent.replaceAll(/{{([A-Z0-9_]+)}}/g, (match, key) => {
    const value = variables[key];

    if (typeof value === 'string' && value.length > 0) {
      return value;
    }

    return match;
  });
};
